// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"ClientContestNavigation_layoutSwitch__ONk2Z","paginationSwitch":"ClientContestNavigation_paginationSwitch__CJSSY"};